/* eslint-disable @typescript-eslint/naming-convention */
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safeUrl',
  standalone: false,
})
export class SafeUrlPipe implements PipeTransform {
  // ✅ Put your approved iframe hosts here
  // Examples: your app domain(s), trusted video providers, trusted schedulers, etc.
  private readonly ALLOWED_HOSTS = new Set<string>([
    'growth99.com',
    'www.growth99.com',
    'app.growth99.com',
    'growthemr.com',
    // 'www.youtube.com',
    // 'player.vimeo.com',
  ]);

  // Optional: allow subdomains of a parent domain
  private readonly ALLOWED_PARENT_DOMAINS = ['growth99.com'];

  constructor(private readonly _sanitizer: DomSanitizer) {}

  transform(value: string): SafeResourceUrl {
    const safe = this.sanitizeUrlStrict(value);
    // If blocked, return empty safe url (iframe won't load)
    return this._sanitizer.bypassSecurityTrustResourceUrl(safe);
  }

  private sanitizeUrlStrict(input: string): string {
    const raw = (input || '').trim();
    if (!raw) {
      return '';
    }

    // ❌ block protocol-relative URLs: //evil.com
    if (raw.startsWith('//')) {
      return '';
    }

    // ✅ allow same-origin relative paths
    if (raw.startsWith('/') || raw.startsWith('./') || raw.startsWith('../')) {
      return raw;
    }

    // Parse absolute URL safely
    let url: URL;
    try {
      url = new URL(raw);
    } catch {
      return '';
    }

    // ✅ only http/https
    if (url.protocol !== 'https:' && url.protocol !== 'http:') {
      return '';
    }

    // Normalize host (lowercase; URL() already does punycode normalization)
    const host = url.hostname.toLowerCase();

    // ✅ allow exact host allowlist
    if (this.ALLOWED_HOSTS.has(host)) {
      return url.toString();
    }

    // ✅ optionally allow subdomains of allowed parent domains
    if (
      this.ALLOWED_PARENT_DOMAINS.some(
        (parent) => host === parent || host.endsWith(`.${parent}`)
      )
    ) {
      return url.toString();
    }

    return '';
  }
}
